const PageContent = (props) => {
  const { children } = props;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        padding: "24px 30px",
      }}
    >
      {children}
    </div>
  );
};

export default PageContent;
